import React from 'react'
import { Icon } from '../../../../../index'
import styles from './styles.module.css'

export function AssetBreadCrumb({ breadcrumbs }) {
  return (
    <div className={styles['breadcrumb']}>
      <Icon icon='Folder' className={styles['mr-5']} />
      {breadcrumbs.map((item, idx) => (
        <span key={idx} style={{ cursor: 'pointer' }} onClick={() => item.action(idx)}>
          {item.displayName} /&nbsp;
        </span>
      ))}
    </div>
  )
}
